import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box/Box';
import Button from '@mui/material/Button/Button';
import TextField from '@mui/material/TextField/TextField';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import TableContainer from '@mui/material/TableContainer/TableContainer';
import Table from '@mui/material/Table/Table';
import TableHead from '@mui/material/TableHead/TableHead';
import TableRow from '@mui/material/TableRow/TableRow';
import TableCell from '@mui/material/TableCell/TableCell';
import TableBody from '@mui/material/TableBody/TableBody';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import { AppStore } from '../../store/applicationState';
import { DeleteForms, GetForms, resetForms, SearchForms } from '../../store/forms/actions';
import { useSearch } from '../../hooks/useSearch';
import { IForms } from '../../store/forms/types';
import { GetCart } from '../../store/cart/actions';
import { WarningModal } from '../../components/modals';
import { ROUTES } from '../../utils/routes';

interface Column {
  id: 'id' | 'title' | 'rubric' | 'template' | 'sample' | 'isPopular' | 'isMonth' | 'delete' | 'isPublic' | 'author';
  label: string;
  align?: 'right' | 'left' | 'center';
  width?: string;
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: 'id', label: '№', align: 'center', width: '6%' },
  { id: 'title', label: 'Заголовок', align: 'left' },
  {
    id: 'isPublic',
    label: 'Публікція',
    align: 'center',
  },
  {
    id: 'isPopular',
    label: 'Популярне',
    align: 'center',
  },
  {
    id: 'isMonth',
    label: 'Форма місяця',
    align: 'center',
  },
  {
    id: 'author',
    label: 'Редактор',
    align: 'left',
  },
  {
    id: 'template',
    label: 'Шаблони',
    align: 'left',
  },
  {
    id: 'sample',
    label: 'Зразки',
    align: 'left',
  },
  {
    id: 'rubric',
    label: 'Рубрика',
    align: 'left',
  },
  {
    id: 'delete',
    label: 'Видалити',
    align: 'center',
    width: '8%',
  },
];

type PropsType = {};

export const ListForms: React.FC<PropsType> = () => {
  const [isModal, setIsModal] = React.useState<{ id: number } | null>(null);
  const [forms, setForms] = React.useState<IForms[]>([]);

  const { Forms, Configurations } = useSelector((store: AppStore) => store);
  const { loading, searchId, searchTitle, resetState, handleSearchId, handleSearchTitle } = useSearch({
    SearchData: SearchForms,
    ResetData: resetForms,
  });
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (Forms.forms) setForms(Forms.forms.filter((el) => !el.is_in_cart));
  }, [Forms]);

  React.useEffect(() => {
    dispatch(resetForms());
  }, [dispatch]);

  const handleChangeRoute =
    (path = '' as string | number) =>
    () => {
      window.open(ROUTES.routeChange(`list/${path}?site_id=${Configurations.siteId}`));
    };

  const handleRemove = (id: number) => {
    dispatch(
      DeleteForms.request({
        id,
        callBack: (success) => {
          if (success) {
            dispatch(
              GetCart.request({
                data: {
                  siteId: Configurations.siteId,
                },
              })
            );
            dispatch(
              GetForms.request({
                data: {
                  siteId: Configurations.siteId,
                },
              })
            );
          }
        },
      })
    );
  };

  const defineForm = (appId: number) => {
    if (appId === 5) return 'форму або зразок';
    if (appId === 2 || appId === 3) return 'зразок';
    return 'форму';
  };

  return (
    <>
      <Box >
        <Button
          
          variant='contained'
          color='primary'
          onClick={handleChangeRoute('new')}
        >
          Створити {defineForm(Configurations.siteId)}
        </Button>
        <TextField
          size='small'
          id='outlined-basic-id'
          label='Пошук по ID'
          variant='outlined'
          value={searchId}
          
          onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
            handleSearchId(event.target.value as string);
          }}
        />
        <TextField
          
          size='small'
          id='outlined-basic-title'
          label='Пошук по заголовку'
          variant='outlined'
          value={searchTitle}
          onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
            handleSearchTitle(event.target.value as string);
          }}
        />
        <Button  variant='contained' color='primary' onClick={resetState}>
          {loading ? <CircularProgress color='inherit' size={25} /> : 'Очистити фільтри'}
        </Button>
      </Box>
      <TableContainer >
        <Table  stickyHeader aria-label='sticky table'>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ width: column?.width || '' }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {forms?.map((row, i) => {
              return (
                <TableRow style={{ maxHeight: 50 }} hover role='checkbox' tabIndex={-1} key={`${i}-${row.id}`}>
                  <TableCell align='center'>
                    <Link sx={{ cursor: 'pointer' }} onClick={handleChangeRoute(row.id)}>
                      {row.id}
                    </Link>
                  </TableCell>
                  <TableCell >{row.title}</TableCell>
                  <TableCell align='center' >
                    {row.isPublic ? <DoneIcon /> : ''}
                  </TableCell>
                  <TableCell align='center' >
                    {row.isPopular ? <DoneIcon /> : ''}
                  </TableCell>
                  <TableCell align='center' >
                    {row.isMonth ? <DoneIcon /> : ''}
                  </TableCell>
                  <TableCell >{row.author ? row.author.fio : ''}</TableCell>
                  <TableCell >
                    {row.files.filter((file) => file.type === 1).length || 0 ? <DoneIcon /> : ''}
                  </TableCell>
                  <TableCell >
                    {row.files.filter((file) => file.type === 2).length || 0 ? <DoneIcon /> : ''}
                  </TableCell>
                  <TableCell >{row.rubricName}</TableCell>
                  <TableCell align='center'>
                    <IconButton aria-label='delete' onClick={() => setIsModal({ id: row.id })}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {isModal ? (
        <WarningModal
          handleApprove={(isApprove) => {
            isApprove && handleRemove(isModal.id);
            setIsModal(null);
          }}
          value={`№ ${isModal.id}`}
          open={!!isModal}
        />
      ) : null}
    </>
  );
};
